// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from '../src/MainPages/HomePage';
import About from '../src/MainPages/About';
import Services from '../src/MainPages/Services';
import Contact from '../src/MainPages/Contact';
import LoginRegister from './LoginRegister'
function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
            <Route path="/signup" element={<LoginRegister />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;